import React from "react";

import { useDmWorkflowToasts } from "../../hooks/useDmWorkflowToasts";
import { useOfferAccountSync } from "../../hooks/useOfferAccountSync";

/**
 * DM ワークフロー WS トーストのグローバルリスナー。
 * Router 配下（useNavigate / useLocation 利用）でマウントする。
 * あわせてオファー状態更新時の残高・進行中の同期も常駐させる。
 */
const DmWorkflowToastBridge: React.FC = () => {
  useDmWorkflowToasts();
  useOfferAccountSync();
  return null;
};

export default DmWorkflowToastBridge;
